import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d424624"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc-text" }, "我们统计了近期不同时期周期内，全市场涨停股与入选股池的标的的区间涨幅对比。", -1))
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "backtest-table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col-tracking" }, "数据跟踪"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-period" }, "统计周期"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "T+3"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "T+5"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "T+10")
  ])
], -1))
const _hoisted_5 = ["rowspan"]
const _hoisted_6 = { class: "col-period cell-border-right" }
const _hoisted_7 = ["rowspan"]
const _hoisted_8 = { class: "col-period cell-border-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dragon-backtest", _ctx.theme])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodData, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: 'limit-' + index
            }, [
              (index === 0)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    rowspan: _ctx.periodData.length,
                    class: "col-tracking cell-border-right"
                  }, "涨停后区间平均最高涨幅", 8, _hoisted_5))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_6, _toDisplayString(item.label), 1),
              _createElementVNode("td", {
                class: _normalizeClass(["col-data", _ctx.getColorClass(item.data?.t3UpRate)])
              }, _toDisplayString(_ctx.formatPercent(item.data?.t3UpRate)), 3),
              _createElementVNode("td", {
                class: _normalizeClass(["col-data", _ctx.getColorClass(item.data?.t5UpRate)])
              }, _toDisplayString(_ctx.formatPercent(item.data?.t5UpRate)), 3),
              _createElementVNode("td", {
                class: _normalizeClass(["col-data", _ctx.getColorClass(item.data?.t10UpRate)])
              }, _toDisplayString(_ctx.formatPercent(item.data?.t10UpRate)), 3)
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodData, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: 'select-' + index
            }, [
              (index === 0)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    rowspan: _ctx.periodData.length,
                    class: "col-tracking cell-border-right"
                  }, "入选后区间平均最高涨幅", 8, _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_8, _toDisplayString(item.label), 1),
              _createElementVNode("td", {
                class: _normalizeClass(["col-data", _ctx.getColorClass(item.data?.t3SelectUpRate)])
              }, _toDisplayString(_ctx.formatPercent(item.data?.t3SelectUpRate)), 3),
              _createElementVNode("td", {
                class: _normalizeClass(["col-data", _ctx.getColorClass(item.data?.t5SelectUpRate)])
              }, _toDisplayString(_ctx.formatPercent(item.data?.t5SelectUpRate)), 3),
              _createElementVNode("td", {
                class: _normalizeClass(["col-data", _ctx.getColorClass(item.data?.t10SelectUpRate)])
              }, _toDisplayString(_ctx.formatPercent(item.data?.t10SelectUpRate)), 3)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 2))
}